<div class="form-group" *ngFor="let field of filteredFields()">
  <div [id]="field.key" class="tooltip" [ngSwitch]="field.controlType">

    <ng-container *ngIf="field.tooltip">
      <span class="tooltiptext">
        <div *ngFor="let line of transformTooltip(field.tooltip)">{{ line | translate }}</div>
      </span>
    </ng-container>

    <app-checkbox-cell *ngSwitchCase="'boolean'" [field]="field"></app-checkbox-cell>
    <app-checkbox-group-cell *ngSwitchCase="'checkboxGroup'" [field]="field" [checkboxTexts]="field.extraData"></app-checkbox-group-cell>
    <app-checkbox-list-cell *ngSwitchCase="'checkboxList'" [field]="field" [params]="field.extraData"></app-checkbox-list-cell>
    <app-colorpicker-cell *ngSwitchCase="'colorPicker'" [field]="field"></app-colorpicker-cell>
    <app-datepick-cell *ngSwitchCase="'date'" [field]="field"></app-datepick-cell>
    <app-datepick-cell *ngSwitchCase="'datetime'" [field]="field"></app-datepick-cell>
    <app-time-cell *ngSwitchCase="'time'" [field]="field"></app-time-cell>

    <app-selectlist-cell *ngSwitchCase="'ddl'" [field]="field" [params]="field.extraData"></app-selectlist-cell>
    <app-selectlist-cell *ngSwitchCase="'ddlMultiple'" [field]="field" [params]="field.extraData"></app-selectlist-cell>

    <app-selectlist-search-cell *ngSwitchCase="'search'" [field]="field" [params]="field.extraData"></app-selectlist-search-cell>
    <app-selectlist-search-cell *ngSwitchCase="'ddlSearch'" [field]="field" [params]="field.extraData"></app-selectlist-search-cell>

    <app-selectlist-control-cell *ngSwitchCase="'ddlControl'" [field]="field" [extraData]="field.extraData" [(constrainedFields)]="fields" [(formGroup)]="formGroup"></app-selectlist-control-cell>

    <app-dnd-cell *ngSwitchCase="'dnd'" [field]="field" [dndList]="field.extraData"></app-dnd-cell>
    <app-translated-cell *ngSwitchCase="'translated'" [field]="field" [languages]="field.extraData"></app-translated-cell>
    <app-textarea-cell *ngSwitchCase="'textarea'" [field]="field"></app-textarea-cell>
    <app-file-cell *ngSwitchCase="'file'" [field]="field"></app-file-cell>

    <app-dynamic-list *ngSwitchCase="'dynamicList'" [field]="field" [extraData]="field.extraData"></app-dynamic-list>

    <app-textbox-cell *ngSwitchDefault [field]="field"></app-textbox-cell>

  </div>
</div>
